import React, { useEffect, useState } from "react";
import { Container, Card } from "react-bootstrap";
import Particle from "../Particle";
import { Link } from "react-router-dom";


function Projects() {
const [projects, setProjects] = useState([]);

 useEffect(() => {
   fetch('./Projects.json')
   .then(res=> res.json())
   .then(data=> {
     setProjects(data);
   })
 })


  return (
    <Container fluid className="project-section">
      <Particle/>
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <div className="row" style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((pd, index)=>(
            <div className="col-md-4 col-sm-12 project-card" data-aos="fade-up" data-aos-anchor-placement="center-bottom">    
              <Card className="CardShow pb-5">
                <Card.Img variant="top" src={pd?.tumbl}/>
                <Card.Title className="ProjectName fs-6">{pd?.name}</Card.Title>       
                <Card.Text className="p-2" style={{fontSize: '15px', color: 'white'}}>{pd?.shortDes}</Card.Text>
                <div className="d-flex justify-content-around">
                <a href={pd?.projectLink} target="_blank" className="btn btn-primary ProjectBtn">Preview</a>
                <Link to={`/singleProject/${pd?.id}`} className="btn btn-primary ProjectBtn">Details</Link>
                </div>
              </Card>
            </div>
          ))}
         
        </div>
      </Container>
    </Container>
  );
}

export default Projects;